import colors from '@/utils/colors';
const { computerColor, mobileColor, notClassifiedColor } = colors;

export default {
  data() {
    return {
      computerColor,
      mobileColor,
      notClassifiedColor,
    };
  },
  methods: {
    getDeviceColor(title) {
      switch (title) {
      case 'Computador':
      case 'Computer':
        return this.computerColor;

      case 'Celular/Tablet':
      case 'Cell Phone/Tablet':
        return this.mobileColor;

      case 'Não Classificados':
      default:
        return this.notClassifiedColor;
      }
    },
    getDeviceName(title) {
      switch (title) {
      case 'Computador':
      case 'Computer':
        return this.$t('mixins.deviceModel.label.computer');

      case 'Celular/Tablet':
      case 'Cell Phone/Tablet':
        return this.$t('mixins.deviceModel.label.mobile');

      default:
        return this.$t('mixins.deviceModel.label.notClassified');
      }
    },
  },
};
